import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { IoLogoWhatsapp } from 'react-icons/io5';
import { useNavigate, useSearchParams } from 'react-router-dom';

import cal from 'generate-calendar-url';
import { t } from 'i18next';
import { Helmet } from 'react-helmet';
import { bookingSuccess } from '../api/api';
import SuccessIcon from '../assets/images/success.svg';
import SendMailModal from '../components/SendMailModal';

export default function Success() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showModel, setShowModel] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({});

  const handleSendEmail = () => {
    setShowModel(true);
  };

  const handleAddToCalendar = () => {
    const courseDetails = JSON.parse(
      sessionStorage.getItem('bookingDetails') || '{}'
    );
    var event = {
      title: courseDetails?.courseName || 'Emstell Course',
      start: new Date(
        courseDetails?.timeDetails?.date
          ? `${courseDetails?.timeDetails?.date} ${courseDetails?.timeDetails?.timefrom} `
          : '1900-01-01 00:00:00'
      ),
      end: new Date(
        courseDetails?.timeDetails?.date
          ? `${courseDetails?.timeDetails?.date} ${courseDetails?.timeDetails?.timeto} `
          : '1900-01-01 00:00:00'
      ),
      location: courseDetails?.location || '',
      description: `Reminder for the course your are booked (${
        courseDetails?.courseName || 'Emstell Course'
      })`,
    };

    window.open(cal.google(event));
  };

  const paymentSuccess = async ({
    bookingId,
    bookingPaymentId,
    gatewayId,
    paymentId,
    uResult,
    uPostDate,
    uRef,
    uTrackId,
    uOrderId,
    uAuth,
    uTranId,
  }) => {
    const { error, data } = await bookingSuccess({
      bookingId,
      bookingPaymentId,
      gatewayId,
      paymentId,
      uResult,
      uPostDate,
      uRef,
      uTrackId,
      uOrderId,
      uAuth,
      uTranId,
    });

    if (
      !error &&
      data?.status === 'Success' &&
      bookingId &&
      paymentId &&
      bookingPaymentId
    ) {
      sessionStorage.setItem('isBookingConfirmed', 'yes');
    }
  };

  useEffect(() => {
    const bookingId = sessionStorage.getItem('bookingId');
    const bookingPaymentId = sessionStorage.getItem('bookingPaymentId');
    const isBookingConfirmed = sessionStorage.getItem('isBookingConfirmed');
    const isPaymentFree = sessionStorage.getItem('isPaymentFree');

    const _bookingDetails = JSON.parse(
      sessionStorage.getItem('bookingDetails') || '{}'
    );

    // for both myFathoorah & uPayment
    const paymentId =
      searchParams.get('paymentId') || searchParams.get('PaymentID');

    // only for uPayment
    const uResult = searchParams.get('Result');
    const uPostDate = searchParams.get('PostDate');
    const uRef = searchParams.get('Ref');
    const uTrackId = searchParams.get('TrackID');
    const uOrderId = searchParams.get('OrderID');
    const uAuth = searchParams.get('Auth');
    const uTranId = searchParams.get('TranID');

    if (isBookingConfirmed === 'yes' || !bookingId) {
      return navigate('/', { replace: true });
    }

    setBookingDetails(
      JSON.parse(sessionStorage.getItem('bookingDetails') || '{}')
    );

    if (!isPaymentFree || isPaymentFree != '1') {
      paymentSuccess({
        bookingId,
        bookingPaymentId,
        gatewayId: _bookingDetails?.gatewayId,
        paymentId,
        uResult,
        uPostDate,
        uRef,
        uTrackId,
        uOrderId,
        uAuth,
        uTranId,
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {t('paymentSuccess')} - {t('emstellCourse')}
        </title>
      </Helmet>
      <>
        <SendMailModal isOpen={showModel} onClose={() => setShowModel(false)} />
        <div className="max-w-5xl mx-auto mt-5 top-0 px-4 lg:px-0">
          <div className="bg-white rounded-3xl p-6 shadow-md shadow-black/5">
            <div className="max-w-sm mx-auto">
              <h2 className="text-green-500 font-semibold text-lg text-center">
                {t('registrationSuccess')}
              </h2>
              <div className="flex justify-center mt-5">
                <img src={SuccessIcon} alt="Success Icon" className="w-10" />
              </div>
              <p className="text-xs text-gray-500 sm:px-10 mt-6 text-center tracking-wide leading-[21px] ">
                {t('successMessage')}
              </p>

              <div className="sm:px-10 text-xs mt-6 space-y-2 font-medium">
                <div className="grid grid-cols-2 gap-2">
                  <div className="flex justify-between">
                    <span>{t('registrationNo')}</span>
                    <span> :</span>
                  </div>
                  <div>#{bookingDetails?.bookingId}</div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="flex justify-between">
                    <span>{t('courseName')}</span>
                    <span> :</span>
                  </div>
                  <div>{bookingDetails?.courseName}</div>
                </div>
                {bookingDetails?.paidAmount != '0' && (
                  <div className="grid grid-cols-2 gap-2">
                    <div className="flex justify-between">
                      <span>{t('paidAmount')}</span>
                      <span> :</span>
                    </div>
                    <div>{bookingDetails?.paidAmount?.toFixed(3)}KWD</div>
                  </div>
                )}

                {/* <div className="grid grid-cols-2 gap-2">
                  <div className="flex justify-between">
                    <span>{t('date')}</span>
                    <span> :</span>
                  </div>
                  <div>{bookingDetails?.timeDetails?.preferredDate}</div>
                </div> */}
                {/* <div className="grid grid-cols-2 gap-2">
                  <div className="flex justify-between">
                    <span>{t('time')}</span>
                    <span> :</span>
                  </div>
                  
                  <div>
                    {`${moment(bookingDetails?.timeDetails?.timefrom, [
                      'HH:mm:ss',
                    ]).format('h:mm A')} - ${moment(
                      bookingDetails?.timeDetails?.timeto,
                      ['HH:mm:ss']
                    ).format('h:mm A')}`}
                  </div>
                </div> */}
                {/* <div className="grid grid-cols-2 gap-2">
                  <div className="flex justify-between">
                    <span>{t('location')}</span>
                    <span> :</span>
                  </div>
                  <div>{bookingDetails?.location}</div>
                </div> */}
              </div>

              <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 justify-between sm:space-x-5 rtl:space-x-reverse mt-5">
                {/* <button
                  className="bg-gradient-to-r from-blue-700 via-violet-600 to-purple-500 text-xs px-6 py-3 rounded-full text-white tracking-wide w-full hover:opacity-90"
                  onClick={handleAddToCalendar}>
                  {t('addToCalender')}
                </button> */}
                {/* <a
                  target={'_blank'}
                  href={`https://calendar.google.com/calendar/u/0/r/eventedit?dates=20230214T091500Z/20230218T223000Z&text=<Text>&location=<Location>&details=<Details>`}
                  className="bg-gradient-to-r from-blue-700 via-violet-600 to-purple-500 text-xs px-6 py-3 rounded-full text-white tracking-wide w-full hover:opacity-90"
                  rel="noreferrer">
                  Add to Calender
                </a> */}
                <button
                  onClick={handleSendEmail}
                  className="bg-gradient-to-r from-blue-700 via-violet-600 to-purple-500 text-xs px-6 py-3 rounded-full text-white tracking-wide w-full hover:opacity-90">
                  {t('sendToEmail')}
                </button>
              </div>

              <div className="flex justify-center mt-5 mb-5">
                <div className="flex space-x-3 sm:space-x-8 rtl:space-x-reverse items-center ">
                  <span className="text-xs text-gray-600">
                    {t('forAnyQueries')}
                  </span>

                  <a
                    href="https://api.whatsapp.com/send/?phone=96550692333&text=Message+from+Launch+Online+Workshop+Success+Page"
                    target="_blank"
                    rel="noreferrer">
                    <IoLogoWhatsapp className="text-green-500" size={25} />
                  </a>
                  {/* <span>9098909890</span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}
